function init_calculate_all_service(form, place_creator) {

    let calculate = new CalculateAllService();

    calculate.calculate('#calculate_form');

    window.globalCalcRequest = false;

    calculate.setPlacesIndexNumber();
    calculate.calculatePlacesWeightAndVolume();

    $(document.body).on('input', function (e) {
        let target = $(e.target);
        let value = target.val();

        //====== CALCULATE PLACE VOLUME =======/

        if (target.attr('class') === 'calc_volume') {
            if (value == "") {
                target.val(0);
            }
            value = value.replace(',', '.');
            target.val(value.replace(/[^0-9.]/g, ''));

            let form = $(e.target).parent('.place-sizes');
            let volume = calculate.calculateVolume($(form).find('input'));

            if (target.val()) {
                $('input[name="' + form.attr('data-for') + '"]').val(volume.toFixed(3)).trigger('change');
                calculate.calculatePlacesWeightAndVolume();
            } else {
                $('input[name="' + form.attr('data-for') + '"]').val('').trigger('change');
            }
        }

        //====== CALCULATE PLACE SIZES =======/

        if (target.attr('class') === 'form-control volume') {
            let val = target.val();

            if (val.split('.')[1]) {
                if (val.split('.')[1].length > 3) {
                    target.val(val.slice(0, -1));
                }
            }

            let form = $(target).closest('.volume-field');
            let size = calculate.calculateSize(val);

            $(form).find('.calc_volume').val(size);
            calculate.calculatePlacesWeightAndVolume();
        }

        //====== CALCULATE ALL WEIGHT AND VOLUME =======/
        if (target.attr('data-type') === 'weight') {
            calculate.calculatePlacesWeightAndVolume();
        }

        return false;
    });

    //====== SERVICE ACCORDION =======/

    $('body').on('click', '.service-label[data-accordion="true"]', function () {
        $(this).toggleClass('in');
        let id = $(this).attr('id');
        $('.service-list[data-parent="' + id + '"]').slideToggle();
    });

    $('#calculate_form').on('afterValidate', function () {

        let error = document.getElementsByClassName('has-error');

        if (error.length > 0) {
            $(error[0]).find('input').focus();
        }
    });
    $("[type=checkbox][data-enable-field]").change(function () {
        let obj = $($(this).data("enable-field"));
        window.t = $(this);
        window.obj = obj;
        if (!$(this).prop("checked")) {
            $(obj).attr("disabled", "disabled");
            //$(obj).val("");
        } else {
            $(obj).removeAttr("disabled");
            //$(obj).val(0);
        }
        if (window.globalCalcRequest) {
            $($('.service-list input[type=checkbox]')[0]).change();
        }
    });


    $('.service-list input[type=checkbox]').change(function (e) {
        e.preventDefault();
        $('#finish-container').find('.loader-circle').fadeIn();
        let el = $('.scroll-result')[0];

        el.scrollIntoView({
            behavior: "smooth"
        });

        let url = '/calculate/result'
        let data = $('#calculate_form').serializeArray();
        let dataService = $('#calculate_form_finish').serializeArray();

        let callback = (result) => {
            calculate.pushResult(result);
        };

        data = data.concat(dataService);
        window.d = data
        if (window.globalCalcRequest) {
            window.globalCalcRequest.abort();
            window.globalCalcRequest = new Ajax({
                url: url,
                data: data,
                callback: callback
            })
        } else {
            window.globalCalcRequest = new Ajax({
                url: url,
                data: data,
                callback: callback
            })
        }

        window.globalCalcRequest.ajaxRequest();
    })
}

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.service-list').forEach(block => {
        let checkboxes = block.querySelectorAll("input[type='checkbox'][value='spb'], input[type='checkbox'][value='hard_pack']");

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', () => {
                checkboxes.forEach(otherCheckbox => {
                    if (otherCheckbox !== checkbox) {
                        otherCheckbox.checked = false;
                    }
                });

                if (!checkbox.checked) {
                    checkboxes.forEach(otherCheckbox => {
                        otherCheckbox.disabled = false;
                    });
                }
            });
        });
    });

    document.querySelectorAll("input[type='checkbox'][value='ipb']").forEach(checkbox => {
        let span = checkbox.nextSibling;
        while (span && span.nodeType !== Node.ELEMENT_NODE) {
            span = span.nextSibling;
        }

        if (span && span.tagName === "SPAN") {
            span.classList.add('ipb');
            checkbox.disabled = true;
        }

        let label = checkbox.closest('label');
        if (label) {
            label.dataset.toggle = 'tooltip';
            label.dataset.placement = 'top';
            label.title = 'Индивидуальный паллетный борт состоит из поддона, деревянных колец и крышки. Он предназначен ' +
                'для грузов одного клиента. Стоимость рассчитывается исходя из фактических размеров груза с учетом' +
                ' упаковки после приемки заказа на склад';
        }
    });

    if (window.bootstrap && bootstrap.Tooltip) {
        document.querySelectorAll('[data-toggle="tooltip"]').forEach(tooltipTriggerEl => {
            new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }
});
